import { render } from "./tableVir.vue?vue&type=template&id=6094659d"
import script from "./tableVir.vue?vue&type=script&lang=js"
export * from "./tableVir.vue?vue&type=script&lang=js"

import "./tableVir.vue?vue&type=style&index=0&id=6094659d&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__